import {
	disableNotificationInterceptors,
	type PostNftTransferPayload,
	type PostNftTransferV2Payload
} from '@capsicum/common';

import { nftApi } from '.';

export async function postMultipleNftTransfer(payload: PostNftTransferV2Payload) {
	return (await nftApi).postNftTransferV2(payload, {
		customErrorInterceptor: disableNotificationInterceptors
	});
}

export async function postNftTransfer(payload: PostNftTransferPayload) {
	return (await nftApi).postNftTransfer(payload, {
		customErrorInterceptor: disableNotificationInterceptors
	});
}
